// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_Q8t","col":"styles_col__4z-Y5","actions":"styles_actions__1KMwT","conflict":"styles_conflict__2_M6C"};